import errors from '../config/errors';
import successes from '../config/successes';
import language from '../config/language';

function cleanupTags(message, opt) {
  const parsed = new DOMParser().parseFromString(message, 'text/html');

  return opt ? `${parsed.body.textContent}: ${opt}` : parsed.body.textContent || '';
}

const suc = language && language.successes
  ? language.successes
  : successes;

const err = language && language.errors
  ? language.errors
  : errors;

export const error = x => document
  .querySelector('#error')
  .MDCSnackbar
  .show({ message: err[x] ? cleanupTags(err[x]) : x });

export const success = (x, opt) => document
  .querySelector('#success')
  .MDCSnackbar
  .show({ message: suc[x] ? cleanupTags(suc[x], opt) : x });
